"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BasicNode_1 = require("./BasicNode");
const types_1 = require("../types");
const DataFormatterNodeValidation_1 = require("../validations/DataFormatterNodeValidation");
class DataFormatterNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.DataFormatter };
    if (props.type !== types_1.NODE_TYPES.DataFormatter)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    return data;
  }
  serialize(uiData) {
    return uiData;
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  validate() {
    return new DataFormatterNodeValidation_1.DataFormatterNodeValidation().validate(
      this
    );
  }
  async getAvailableResources() {
    return [
      {
        selectedResourceId: this.getNodeId(),
        label: [this.getNodeName(), "Data"].join("."),
        nodeRef: this,
        path: "",
        context: {
          outputPath: ""
        }
      }
    ];
  }
  async getOutputKeys(params) {
    const { data, resource } = params || {};
    const nodeData = data || this.getNodeData();
    let selectedResource = this.getSelectedResource();
    if (!selectedResource) return [];
    let { nodeRef } = selectedResource;
    if (!nodeRef) return [];
    try {
      const reOutputKeys = await nodeRef.getOutputKeys(params);
      if (!nodeData) return reOutputKeys;
    } catch (e) {
      console.error(e);
      return [];
    }
    const customOutputKeys = nodeData.customKeys.map(({ key }) => ({
      name: key,
      value: key
    }));
    const selectedOutputKeys = Object.entries(nodeData.selectKeys).map(
      ([name, value]) => ({
        name,
        value
      })
    );
    if (nodeData.type === types_1.DataFormatterOptionType.DATA) {
      return customOutputKeys;
    }
    if (nodeData.type === types_1.DataFormatterOptionType.OBJ) {
      const filteredSelectedKeys = selectedOutputKeys.filter(
        x => customOutputKeys.findIndex(y => y.name === x.name) === -1
      );
      return filteredSelectedKeys.concat(customOutputKeys);
    }
    return [];
  }
}
exports.DataFormatterNode = DataFormatterNode;
//# sourceMappingURL=DataFormatterNode.js.map
